import { find } from 'lodash-es';

export default {
  props: ['className', 'product', 'active'],
  delimiters: ['#{', '}'],
  data: function () {
    return {}
  },
  computed: {
    color() {
      return this.product.title.split(window.theme.settings.style_delimiter)[1].trim()
    },
    images() {
      return this.product.images.edges.map(edge => edge.node)
    },
    swatchSrc() {
      const swatch = find(this.images, image => {
        return image.altText == 'swatch'
      })
      if (swatch) {
        return swatch.src
      } else {
        let defaultSwatch = find(window.theme.defaultSwatches, (s) => {
          return this.color.toLowerCase().indexOf(s.color.toLowerCase()) > -1
        })
        if (defaultSwatch) {
          return defaultSwatch.image
        }
      }
    }
  },
  template: `
    <div :class="className">
      <a
      v-if="product"
      :title="product.title"
      :href="product.url"
      :class="{ active: active }"
      class="swatch block w-7 h-7">
        <img
          v-if="swatchSrc"
          class-name="w-full h-full object-cover"
          :src="swatchSrc"
          crop-aspect-ratio=1
          :alt="product.title"
          />
        <div v-else class="bg-grey w-full h-full"></div>
      </a>
      <div v-else class="bg-grey w-7 h-7"></div>
    </div>
  `
};
